import { formatDate } from '@progress/kendo-intl';
import { GridCellProps } from '@progress/kendo-react-grid';
import { convertDate } from 'src/utils/transformation';
import GridCellBase, { useGridCellDisplayValue } from '../GridCellBase';

const UploadDate = (props: GridCellProps) => {
  const { value } = useGridCellDisplayValue(props);
  const uploadDate = formatDate(convertDate(value), 'MM/dd/yyyy h:mm:ss');
  return (
    <GridCellBase {...props} title={uploadDate}>
      <span>{uploadDate}</span>
    </GridCellBase>
  );
};
export default UploadDate;
